import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
    EwalletClosureDocumentDto,
    EwalletClosureDocumentService,
} from '../../../_services/configuration-services';
import {firstValueFrom} from 'rxjs';
import {DateUtils} from '../../../_shared/date-utils';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import * as fileSaver from 'file-saver';

@Component({
    selector: 'app-ewallet-closure-documents',
    templateUrl: './ewallet-closure-documents.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EwalletClosureDocumentsComponent implements OnInit {

    closureDocuments: EwalletClosureDocumentDto[] = [];

    DateUtils = DateUtils;
    icons = {
        download: faDownload
    }

    constructor(private readonly ewalletClosureDocumentService: EwalletClosureDocumentService) {
    }

    ngOnInit(): void {
        this.ewalletClosureDocumentService.getEwalletClosureDocuments().subscribe(closureDocuments => {
            this.closureDocuments = closureDocuments
        });
    }

    async downloadClosureDocument(document: EwalletClosureDocumentDto): Promise<void> {
        const file = await firstValueFrom(this.ewalletClosureDocumentService.downloadEwalletClosureDocument(document.id));
        fileSaver.saveAs(file.data, file.fileName);
    }

}
